'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive Tooltip
 * ROLE: tooltip | ARIA: aria-describedby wired by Radix via TooltipContent id
 * KEYBOARD: shows on focus-visible; ESC closes; Tab/Shift+Tab navigate away
 * FOCUS: does not trap focus; trigger is the focusable element
 * LIVE-REGION: none (tooltip content is SR-exposed via aria-describedby)
 * PRM: animation disabled; opacity instant
 * TOUCH: does NOT show on touch-only devices — content must also be conveyed inline
 * FORCED-COLORS: content border = ButtonText; accent arrow fill = Canvas, stroke = ButtonText
 * RTL: side/align flips via Radix; direction-agnostic
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/tooltip/
 * SUBSTRATE: @radix-ui/react-tooltip
 */
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cx } from '../../utils/cx';
import styles from './Tooltip.module.css';
export function Tooltip({ content, children, side = 'top', align = 'center', sideOffset = 6, delayDuration = 400, open, onOpenChange, tone = 'default', }) {
    return (_jsx(RadixTooltip.Provider, { delayDuration: delayDuration, children: _jsxs(RadixTooltip.Root, { ...(open !== undefined ? { open } : {}), ...(onOpenChange !== undefined ? { onOpenChange } : {}), children: [_jsx(RadixTooltip.Trigger, { asChild: true, children: children }), _jsx(RadixTooltip.Portal, { children: _jsxs(RadixTooltip.Content, { className: cx(styles.content, tone === 'accent' && styles.accent), side: side, align: align, sideOffset: sideOffset, children: [content, tone === 'accent' ? (
                            // An open path (no base edge) with the card fill tucked 1px
                            // into the bubble: bordered slants, no seam, and the 12×6
                            // geometry Radix reserves is exactly what renders. The
                            // default tone stays arrowless — pre-existing tooltips keep
                            // their original placement.
                            _jsx(RadixTooltip.Arrow, { asChild: true, width: 12, height: 6, children: _jsx("svg", { className: styles.arrowAccent, width: "12", height: "6", viewBox: "0 0 12 6", "aria-hidden": true, children: _jsx("path", { d: "M0,0 L6,6 L12,0" }) }) })) : null] }) })] }) }));
}
//# sourceMappingURL=Tooltip.js.map